import {EditorSelection} from '@codemirror/state'
import type {Command, EditorView} from '@codemirror/view'

import {createText} from '../extensions/single-line-editor'
import {hasNonEmptySelection} from '../utils'

const wrapSelectionWithDelimiter = (view: EditorView, delimiter: string) => {
  if (!view || typeof delimiter !== 'string' || delimiter.length === 0) {
    return
  }

  view.dispatch(
    view.state.changeByRange(range => ({
      changes: [
        {from: range.from, insert: delimiter},
        {from: range.to, insert: delimiter},
      ],
      range: EditorSelection.range(range.from + delimiter.length, range.to + delimiter.length),
      userEvent: 'input',
      scrollIntoView: true,
    })),
  )
}

// If no text is selected, put "<delimiter>" before the current caret position and "<delimiter>" after it
const insertDelimiterAtSelection = (view: EditorView, delimiter: string) => {
  const caretLocation = view.state.selection.main.anchor

  view.dispatch({
    changes: [
      {
        from: caretLocation,
        insert: createText(`${delimiter}${delimiter}`),
      },
    ],
    selection: {anchor: caretLocation + delimiter.length},
    userEvent: 'input',
    scrollIntoView: true,
  })
}

export const formatBold: Command = (view: EditorView) => {
  if (hasNonEmptySelection(view.state)) {
    wrapSelectionWithDelimiter(view, '**')
  } else {
    insertDelimiterAtSelection(view, '**')
  }

  return true
}

export const formatItalic: Command = (view: EditorView) => {
  if (hasNonEmptySelection(view.state)) {
    wrapSelectionWithDelimiter(view, '_')
  } else {
    insertDelimiterAtSelection(view, '_')
  }

  return true
}

export const formatInlineCode: Command = (view: EditorView) => {
  if (hasNonEmptySelection(view.state)) {
    wrapSelectionWithDelimiter(view, '`')
  } else {
    insertDelimiterAtSelection(view, '`')
  }

  return true
}
